export const colors = {
  brandPrimaryDefault: "#ef6000",
  brandPrimaryTint: "#FFE5D1",
  brandPrimaryShade: "#8E4918",
  brandSecondaryDefault: "#054A71",
  brandSecondaryTint: "#B3D4DF",
  brandSecondaryShade: "#051725",
  brandGradientDefault: "linear-gradient(125deg, #052855 0%, #052855 100%)",
  brandGradientColorStopsStart: "#052855",
  brandGradientColorStopsEnd: "#052855",
  productColorsPrimaryL5: "#FFF2E8",
  productColorsPrimaryL4: "#FFE5D1",
  productColorsPrimaryL3: "#FFCBA5",
  productColorsPrimaryL2: "#FFB07A",
  productColorsPrimaryL1: "#FF954E",
  productColorsPrimary: "#ef6000",
  productColorsPrimaryD1: "#C94e08",
  productColorsPrimaryD2: "#8E4918",
  productColorsPrimaryD3: "#5E3214",
  productColorsPrimaryD4: "#311D0E",
  productColorsSecondaryL5: "#e6f1f4",
  productColorsSecondaryL4: "#B3D4DF",
  productColorsSecondaryL3: "#80B7CA",
  productColorsSecondaryL2: "#4D9AB5",
  productColorsSecondaryL1: "#006E95",
  productColorsSecondary: "#054A71",
  productColorsSecondaryD1: "#04315D",
  productColorsSecondaryD2: "#162740",
  productColorsSecondaryD3: "#081F30",
  productColorsSecondaryD4: "#051725",
  contentStrong: "#ffffff",
  contentDefault: "#CED4DB",
  contentSubtle: "#969DA3",
  contentDisabled: "#ffffff33",
  contentOnLight: "#011638",
  contentBrandPrimary: "#ef6000",
  contentBrandSecondary: "#B3D4DF",
  contentLoadingDefault: "#ffffff0d",
  contentLoadingInverse: "#0a0a0a0d",
  contentLink: "#64AEFF",
  contentLinkActive: "#0070EB",
  backgroundBase: "#162740",
  backgroundSurface: "#051725",
  backgroundLayer: "#081F30",
  backgroundAccent: "#ffffff0d",
  backgroundHover: "#04315D",
  backgroundDisabled: "#04315D",
  backgroundTransparent: "#0a0a0a00",
  backgroundSecondary: "#0a0a0a",
  backgroundBrand: "#ef6000",
  backgroundGradientSurfaceFadeEnd: "linear-gradient(90deg, #0a0a0a00 0%, #051725 100%)",
  backgroundGradientSurfaceFadeBottom: "linear-gradient(180deg, #0a0a0a00 0%, #051725 100%)",
  backgroundGradientColorStopsStart: "#0a0a0a00",
  backgroundGradientColorStopsEnd: "#051725",
  borderDefault: "#6A6F73",
  borderSubtle: "#4D5153",
  borderActive: "#64AEFF",
  borderDisabled: "#ffffff1a",
  borderInverse: "#EAF0F6",
  borderBrand: "#ef6000",
  linkDefaultBase: "#64AEFF",
  linkDefaultHover: "#0070EB",
  linkDestructiveBase: "#EA6875",
  linkDestructiveHover: "#D22839",
  systemInfoBackgroundDefault: "#004EA3",
  systemInfoBackgroundSubtle: "#002650",
  systemInfoBorderDefault: "#004EA3",
  systemInfoContentOnSubtle: "#ffffff",
  systemInfoContentAccent: "#99CAFF",
  systemInfoLinkOnSubtle: "#ffffff",
  systemPositiveBackgroundDefault: "#005D23",
  systemPositiveBackgroundSubtle: "#002E11",
  systemPositiveBorderDefault: "#005D23",
  systemPositiveContentOnSubtle: "#ffffff",
  systemPositiveContentAccent: "#7FD9A1",
  systemPositiveLinkOnSubtle: "#ffffff",
  systemAlertBackgroundDefault: "#756100",
  systemAlertBackgroundSubtle: "#4B3F00",
  systemAlertBorderDefault: "#756100",
  systemAlertContentOnDefault: "#ffffff",
  systemAlertContentOnSubtle: "#ffffff",
  systemAlertContentAccent: "#FFDC2E",
  systemAlertLinkOnDefault: "#ffffff",
  systemAlertLinkOnSubtle: "#ffffff",
  systemWarningBackgroundDefault: "#A44800",
  systemWarningBackgroundSubtle: "#692E00",
  systemWarningBorderDefault: "#A44800",
  systemWarningContentOnDefault: "#ffffff",
  systemWarningContentOnSubtle: "#ffffff",
  systemWarningContentAccent: "#FFB77E",
  systemWarningLinkOnDefault: "#ffffff",
  systemWarningLinkOnSubtle: "#ffffff",
  systemImportantBackgroundDefault: "#A40023",
  systemImportantBackgroundSubtle: "#40020D",
  systemImportantBorderDefault: "#A40023",
  systemImportantContentOnSubtle: "#ffffff",
  systemImportantContentAccent: "#F198A1",
  systemImportantLinkOnSubtle: "#ffffff",
  systemNeutralBackgroundDefault: "#6A6F73",
  systemNeutralBackgroundSubtle: "#2B2D2E",
  systemNeutralBorderDefault: "#6A6F73",
  systemNeutralContentOnDefault: "#ffffff",
  systemNeutralContentOnSubtle: "#ffffff",
  systemNeutralContentAccent: "#CED4DB",
  systemNeutralLinkOnDefault: "#ffffff",
  systemNeutralLinkOnSubtle: "#ffffff",
  systemVerificationBackgroundDefault: "#61019B",
  systemVerificationBackgroundSubtle: "#36005B",
  systemVerificationBorderDefault: "#61019B",
  systemVerificationContentOnSubtle: "#ffffff",
  systemVerificationContentAccent: "#D4B6FE",
  systemVerificationLinkOnSubtle: "#ffffff",
  componentButtonPrimaryContentBase: "#0a0a0a",
  componentButtonPrimaryContentHover: "#0a0a0a",
  componentButtonPrimaryContentActive: "#0a0a0a",
  componentButtonPrimaryContentDisabled: "#ffffff33",
  componentButtonPrimaryBackgroundBase: "#ef6000",
  componentButtonPrimaryBackgroundHover: "#C94e08",
  componentButtonPrimaryBackgroundActive: "#8E4918",
  componentButtonPrimaryBackgroundDisabled: "#04315D",
  componentButtonPrimaryBorderBase: "#ef6000",
  componentButtonPrimaryBorderHover: "#C94e08",
  componentButtonPrimaryBorderActive: "#8E4918",
  componentButtonPrimaryBorderDisabled: "#ffffff1a",
  componentButtonSecondaryContentDisabled: "#ffffff33",
  componentButtonSecondaryBackgroundDisabled: "#04315D",
  componentButtonSecondaryBorderDisabled: "#ffffff1a",
  componentButtonTertiaryContentBase: "#ef6000",
  componentButtonTertiaryContentHover: "#C94e08",
  componentButtonTertiaryContentDisabled: "#ffffff33",
  componentButtonTertiaryBackgroundBase: "#0a0a0a00",
  componentButtonTertiaryBackgroundHover: "#311D0E",
  componentButtonTertiaryBackgroundActive: "#C94e08",
  componentButtonTertiaryBackgroundDisabled: "#0a0a0a00",
  componentButtonTertiaryBorderBase: "#ef6000",
  componentButtonTertiaryBorderHover: "#FF954E",
  componentButtonTertiaryBorderActive: "#C94e08",
  componentButtonTertiaryBorderDisabled: "#ffffff1a",
  componentButtonTransparentContentDisabled: "#ffffff33",
  componentButtonTransparentBackgroundBase: "#0a0a0a00",
  componentButtonTransparentBackgroundActive: "#005FC8",
  componentButtonTransparentBackgroundDisabled: "#0a0a0a00",
  componentButtonTransparentBorderActive: "#0a0a0a00",
  componentButtonTransparentBorderDisabled: "#ffffff1a",
  componentButtonDestructiveContentDisabled: "#ffffff33",
  componentButtonDestructiveBackgroundHover: "#A40023",
  componentButtonDestructiveBackgroundActive: "#83001C",
  componentButtonDestructiveBackgroundDisabled: "#04315D",
  componentButtonDestructiveBorderHover: "#A40023",
  componentButtonDestructiveBorderActive: "#83001C",
  componentButtonDestructiveBorderDisabled: "#ffffff1a",
  componentButtonButtonLinkContentBase: "#64AEFF",
  componentButtonButtonLinkContentHover: "#0070EB",
  componentButtonButtonLinkContentDisabled: "#3C3E40",
  componentButtonButtonLinkBackgroundBase: "#0a0a0a00",
  componentButtonButtonLinkBackgroundHover: "#002650",
  componentButtonButtonLinkBackgroundDisabled: "#0a0a0a00",
  componentButtonButtonLinkBorderBase: "#0a0a0a00",
  componentButtonButtonLinkBorderHover: "#0a0a0a00",
  componentButtonButtonLinkBorderActive: "#0a0a0a00",
  componentButtonButtonLinkBorderDisabled: "#ffffff1a",
  componentSelectionControlBackgroundBase: "#051725",
  componentSelectionControlBackgroundHover: "#04315D",
  componentSelectionControlBackgroundActive: "#FF954E",
  componentSelectionControlBackgroundSelected: "#ef6000",
  componentSelectionControlBackgroundSelectedHover: "#99CAFF",
  componentSelectionControlBackgroundSelectedActive: "#99CAFF",
  componentSelectionControlBackgroundUnselected: "#4D5153",
  componentSelectionControlBackgroundDisabled: "#04315D",
  componentSelectionControlBackgroundSuccess: "#31C268",
  componentSelectionControlBackgroundError: "#EA6875",
  componentSelectionControlBorderBase: "#6A6F73",
  componentSelectionControlBorderHover: "#FF954E",
  componentSelectionControlBorderActive: "#FF954E",
  componentSelectionControlBorderSelected: "#ef6000",
  componentSelectionControlBorderSelectedHover: "#99CAFF",
  componentSelectionControlBorderSelectedActive: "#99CAFF",
  componentSelectionControlBorderUnselected: "#4D5153",
  componentSelectionControlBorderDisabled: "#ffffff1a",
  componentSelectionControlBorderSuccess: "#1BB152",
  componentSelectionControlBorderError: "#EB4758",
  componentSelectionControlForegroundBase: "#0a0a0a00",
  componentSelectionControlForegroundHover: "#0a0a0a00",
  componentSelectionControlForegroundActive: "#ef6000",
  componentSelectionControlForegroundSelected: "#011638",
  componentSelectionControlForegroundSelectedHover: "#011638",
  componentSelectionControlForegroundSelectedActive: "#011638",
  componentSelectionControlForegroundUnselected: "#0a0a0a00",
  componentSelectionControlForegroundDisabled: "#ffffff33",
  componentSelectionControlForegroundSuccess: "#011638",
  componentSelectionControlForegroundError: "#011638",
  componentDataInputBackgroundBase: "#051725",
  componentDataInputBackgroundLayer: "#081F30",
  componentDataInputBackgroundHover: "#04315D",
  componentDataInputBackgroundError: "#40020D",
  componentDataInputBackgroundDisabled: "#04315D",
  componentDataInputBorderBase: "#6A6F73",
  componentDataInputBorderActive: "#004EA3",
  componentDataInputBorderError: "#A40023",
  componentDataInputBorderDisabled: "#ffffff1a",
  componentDataInputContentBase: "#CED4DB",
  componentDataInputContentSubtle: "#969DA3",
  componentDataInputContentHover: "#99CAFF",
  componentDataInputContentError: "#F198A1",
  componentDataInputContentDisabled: "#ffffff33",
  componentDataInputLabelBase: "#ffffff",
  componentDataInputLabelActive: "#99CAFF",
  componentDataInputLabelError: "#F198A1",
  componentDataInputLabelDisabled: "#ffffff33",
  componentDataInputPasswordMeterEmpty: "#6A6F73",
  componentDataInputPasswordMeterWeak: "#A40023",
  componentDataInputPasswordMeterFair: "#A44800",
  componentDataInputPasswordMeterGood: "#004EA3",
  componentDataInputPasswordMeterGreat: "#005D23",
  componentDataInputIconBase: "#969DA3",
  componentDataInputIconActive: "#99CAFF",
  componentDataInputIconError: "#F198A1",
  componentDataInputIconDisabled: "#ffffff33",
  componentPillPrimaryContentBase: "#ffffff",
  componentPillPrimaryContentHover: "#ffffff",
  componentPillPrimaryContentSelected: "#011638",
  componentPillPrimaryContentActive: "#011638",
  componentPillPrimaryContentDisabled: "#0a0a0a",
  componentPillPrimaryBackgroundBase: "#ffffff1a",
  componentPillPrimaryBackgroundHover: "#ffffff4d",
  componentPillPrimaryBackgroundSelected: "#64AEFF",
  componentPillPrimaryBackgroundActive: "#2B90FF",
  componentPillPrimaryBackgroundDisabled: "#2B2D2E",
  componentPillInverseContentHover: "#ffffff",
  componentPillInverseContentSelected: "#011638",
  componentPillInverseContentActive: "#011638",
  componentPillInverseContentDisabled: "#0a0a0a",
  componentPillInverseBackgroundBase: "#0a0a0a00",
  componentPillInverseBackgroundHover: "#ffffff4d",
  componentPillInverseBackgroundSelected: "#64AEFF",
  componentPillInverseBackgroundActive: "#2B90FF",
  componentPillInverseBackgroundDisabled: "#2B2D2E",
  componentTabPrimaryLabelBase: "#ffffff",
  componentTabPrimaryLabelHover: "#0070EB",
  componentTabPrimaryLabelActive: "#64AEFF",
  componentTabPrimaryDescriptionBase: "#969DA3",
  componentTabPrimaryDescriptionHover: "#969DA3",
  componentTabPrimaryDescriptionActive: "#969DA3",
  componentTabPrimaryIndicatorBase: "#0a0a0a00",
  componentTabPrimaryIndicatorHover: "#0070EB",
  componentTabPrimaryIndicatorActive: "#64AEFF",
  componentTabPrimaryBackgroundBase: "#0a0a0a00",
  componentTabPrimaryBackgroundHover: "#0a0a0a00",
  componentTabPrimaryBackgroundActive: "#0a0a0a00",
  componentTabPrimaryIconBase: "#ffffff",
  componentTabPrimaryIconHover: "#0070EB",
  componentTabPrimaryIconActive: "#64AEFF",
  componentTabInverseIndicatorBase: "#0a0a0a00",
  componentTabInverseIndicatorHover: "#EAF0F6",
  componentTabInverseIndicatorActive: "#EAF0F6",
  componentTabInverseBackgroundBase: "#0a0a0a00",
  componentTabInverseBackgroundHover: "#0a0a0a00",
  componentTabInverseBackgroundActive: "#0a0a0a00",
};

export const text = {
  themeName: "Mohegan Sun",
};